<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 18 18"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M16.536 5.236l-1.637 1.622-3.263-3.262 1.621-1.636a.76.76 0 0 1 1.05 0l2.228 2.227c.14.14.217.327.217.525a.736.736 0 0 1-.216.524zM6.9 14.588v-.595c0-.14-.08-.269-.205-.332l-1.024-.512 7.134-7.134 1.367 1.366zm-.742.61zm-1.776.507l-1.793-1.792.508-1.776h.975l.64 1.28c.036.071.094.13.166.166l1.28.64v.975zm-2.51.717l.484-1.692 1.21 1.209zm9.042-12.299L12.28 5.49l-7.134 7.134-.512-1.024a.371.371 0 0 0-.332-.206h-.595zm5.946-.472l-2.228-2.23c-.56-.561-1.537-.562-2.1.002L2.552 11.499a.374.374 0 0 0-.093.16L.975 16.86a.372.372 0 0 0 .459.459l5.197-1.486a.373.373 0 0 0 .16-.094L16.86 5.752c.28-.28.435-.653.435-1.05s-.155-.77-.435-1.051z"
        />
      </g>
      <g>
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="50"
          stroke-width="0.5"
          d="M16.336 5.236l-1.637 1.622-3.263-3.262 1.621-1.636a.76.76 0 0 1 1.05 0l2.228 2.227c.14.14.217.327.217.525a.736.736 0 0 1-.216.524zM6.9 14.588v-.595c0-.14-.08-.269-.205-.332l-1.024-.512 7.134-7.134 1.367 1.366zm-.742.61v0h0zm-1.776.507l-1.793-1.792.508-1.776h.975l.64 1.28c.036.071.094.13.166.166l1.28.64v.975zm-2.51.717l.484-1.692 1.21 1.209zm9.042-12.299L12.28 5.49l-7.134 7.134-.512-1.024a.371.371 0 0 0-.332-.206h-.595zm5.946-.472l-2.228-2.23c-.56-.561-1.537-.562-2.1.002L2.552 11.499a.374.374 0 0 0-.093.16L.975 16.86a.372.372 0 0 0 .459.459l5.197-1.486a.373.373 0 0 0 .16-.094L16.86 5.752c.28-.28.435-.653.435-1.05s-.155-.77-.435-1.051z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#3B334A',
    },
    size: {
      type: String,
      default: '12',
    },
  },
};
</script>
